import React from 'react';
import { LayoutRoot, Wrapper, Content, Container, BannersSection, BannersInner } from './elements';
import { PageLoader } from 'features/shared/PageLoader';
import Header from './components/Header';
import AdvertisementPopup from 'features/shared/AdvertisementPopup';
import MainPagePromoBanner from 'features/shared/Banners/MainPagePromoBanner';
import { useLocation } from 'react-router-dom';
import Feedback from 'features/shared/Feedback';

interface MainProps {
  ready: boolean;
}

const Main = (props: React.PropsWithChildren<MainProps>) => {
  const location = useLocation();
  const isMainPage = /^\/main(\/|$)/.test(location.pathname);

  return (
    <LayoutRoot data-testid="main-layout">
      {isMainPage && (
        <BannersSection>
          <BannersInner>
            <MainPagePromoBanner />
          </BannersInner>
        </BannersSection>
      )}
      <Header />
      <Wrapper>
        <Container>
          <Content>
            {props.ready ? props.children : <PageLoader />}
          </Content>
        </Container>
        <AdvertisementPopup ready={props.ready} />
        <Feedback />
      </Wrapper>
    </LayoutRoot>
  );
};

export default Main;
